import PropTypes from 'prop-types';
import icons from './icons';

export const getPropType = (type, field) => {
  const values = Object.keys(type).map(key => type[key]);

  return field
    ? PropTypes.oneOf(values.map(val => val[field]))
    : PropTypes.oneOf(values);
};

export const getPropTypeCode = (type) => PropTypes.oneOf(Object.keys(type));

export const droppable = require('./droppable');
export const fields = require('./fields');
export const filter = require('./filter');
export const pipeline = require('./pipeline');
export const ui = require('./ui');

export const fieldCodes = Object.keys(fields).reduce((prev, curr) => ({
  ...prev,
  [fields[curr].name]: curr,
}), {});

export default {
  getPropType,
  getPropTypeCode,
  droppable,
  fields,
  fieldCodes,
  filter,
  icons,
  pipeline,
  ui,
}